import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`
  @font-face {
    font-family: "Motiva Sans Light";
    src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
    font-style: normal;
  }

  @font-face {
    font-family: "Motiva Sans Bold";
    src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
    font-style: normal;
  }

  html,
  body,
  a {
    font-family: 'Motiva Sans Light', sans-serif;
  }

body {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  background-image: url("/img/background.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  overflow-x: hidden;
}


  a {
    text-decoration: none;
    outline: none;
    color: #004d40;

    &:hover {
      color: #00352e;
    }
  }

  input,
  textarea {
    border-radius: 4px;
    border: 0;
    background: #f1f2f3;
    transition: all 0.3s ease-in-out;
    outline: none;
    width: 100%;
    padding: 1rem 1.25rem;

    &:focus {
      background: none;
      box-shadow: 0 0 0 1px #004d40;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: 'Motiva Sans Bold', serif;
    color: #30472bff;
    font-size: 56px;
    line-height: 1.18;

    @media only screen and (max-width: 890px) {
      font-size: 47px;
    }

    @media only screen and (max-width: 414px) {
      font-size: 32px;
    }
  }

  p {
    color: #1b1b1b;
    font-size: 21px;
    line-height: 1.41;
  }

  h1 {
    font-weight: 600;
  }

  *:focus {
    outline: none;
  }

  .about-block-image svg {
    text-align: center;
  }

  .ant-drawer-body {
    display: flex;
    flex-direction: column;
    text-align: left;
    padding-top: 1.5rem;
  }

  .ant-drawer-content-wrapper {
    width: 300px !important;
  }
`;
